import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from './../Services/common.service';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";
import { CookieService } from '../Services/cookie';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { AuthService } from '../Services/auth.service';
import { PinService } from '../Services/pin.service';
import { CardServiceService } from '../Services/card-service.service';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'app-change-card-pin-confirm',
  templateUrl: './change-card-pin-confirm.component.html',
  standalone:false,
  styleUrls: ['./change-card-pin-confirm.component.scss']
})
export class ChangeCardPinConfirmComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  @ViewChild('otpInput') otpInput!: NgOtpInputComponent;
  otp: string = "";
  otp1: string;
  otpform: FormGroup;
  showError: boolean = false; // Initial value is false, meaning no error is shown.
  myCpr: string;
  InternalID: string;
   eVerifyOTP: string = "";
  maskedEmail: any;
  mobilNomasked: any;
  timeoutHandle: any;
  timerexpire: string;
  OptTimerbtnShow: boolean = false;
  maskMobileNO: any;


  constructor(private router:Router,  public commonP: CommonService,private pin: PinService, public errorKey: ErrorMessageKeyService,private fb: FormBuilder, public translate: TranslateService, private location: Location,private cookieService: CookieService, public auth: AuthService,public cardService:CardServiceService) {

    this.otpform = new FormGroup({
      changeotp: new FormControl("", Validators.compose([
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9]*$"),
        Validators.minLength(4),
      ])),
      //  Validators.maxLength(35)
      // bankbranchcodeoptional: new FormControl("", Validators.compose([Validators.pattern("[0-9]*")])),
      // bankbranchname: new FormControl("", Validators.compose([Validators.required])),
      // , Validators.pattern("[a-zA-Z 0-9 _\"'\\?\\-\\/.,@!]*"),
    });
    }

  async ngOnInit(): Promise<void> {

//  this.myCpr =await this.cookieService.get("myCpr",false);
// console.log(this.myCpr,"cpr123"); // This will log the value of the "myCpr" cookie

    let BN = await this.cookieService.get("cardNewotp", false);
    if (BN) {
      this.otp1 = BN;
      console.log(this.otp1,"otp1");
      

    }
    let BI = await this.cookieService.get("InternallID", false);
    if (BI) {
      this.InternalID = BI;
      console.log("internalidss",this.InternalID);
      

    }
    this.commonP.presentLoading();
    this.auth.accessToken = await this.commonP.Get("token");
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
       this.commonP.hideLoading();
       console.log("verifytokendata",data);
       


      }
      else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this.router, data);
      }

    });

  }


  onKeyDown(event: KeyboardEvent): void {

    if (event.key === 'Enter') {
      // this.LoginRegisterEmailOTP();

    }
  }

  // onOtpChange(e) {
  //   this.otp=""
  //   if (e.length == 4) {
  //     this.otp = e.toString();
  //   } else {
  
  //   }
  // }

  onOtpChange(e: string) {
    if (e.length === 4) {
      this.otp = e; // Set the entered OTP.
      this.showError = this.otp !== this.otp1; // Validate against the expected OTP.
    } else {
      this.showError = false; // Hide the error while the user is still entering the OTP.
    }
  }
  


  // isValid() {
  //   if (!this.otp) {
  //     return true
  //   } else {
  //     return false

  //   }
  // }

  isValid(): boolean {
    // Disable the button if `otp` is undefined, empty, or does not match `otp1`
    if (!this.otp || this.otp !== this.otp1) {
      return true; // Button remains disabled
    }
    return false; // Button is enabled
  }

  back() {
    this.location.back()
  }
  



  getMessage(key, control) {

    let error = "";
    this.translate.get([key]).subscribe((data) => {
      if (control == "officeno") {
        if (key == "MobileMin") {
          error = data[key];
          // error = error.replace("{minLength}", this.mobileminlength.toString());
        } else if (key == "MobileMax") {
          error = data[key];
          // error = error.replace("{maxLength}", this.mobilemaxlength.toString());
        } else {
          error = data[key];
        }
      } else {
        error = data[key];
      }
    });
    return error;
  }


  back2sinnad(){

    this.cookieService.set("cardNewotp", "",true);
    this.router.navigateByUrl("/ChangeCardPinSinnad"); 
  }


  // next(){
  //   this.router.navigateByUrl("/ChangeCardPinSinnadSuccess"); 
  // }

    showModal(num, data) {
    if (data == "close") {
      this.modalObservable.next(data);
    }
    this.modalObservable.next(num);
  }



  next() {
    // 
    // this.commonP.presentLoading();
    let body = {
      InternalId: this.InternalID,
      Status: "SETPIN",
      StopReasonCode: "",
      newPIN: this.otp
    };
    this.cardService.UpdateCardStatus(body,this.auth.accessToken).then((res: any) => {
      //
      console.log("UpdateCardStatus", res);
      if (res?.response?.code == 1) {
        this.commonP.hideLoading();
     // blank the internal id

      this.cookieService.set("InternallID", "",true);
     // 
        this.router.navigateByUrl("/ChangeCardPinSinnadSuccess");
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "OK", this.router, res);
      }
    });
  }

  // new implementation sinnad email/mobile

  //  startTime() {
  //   var str = "1:57";

  //   var array = str.split(":");
  //   this.countdown(parseInt(array[0]), parseInt(array[1]));
  // }
  // countdown(minutes, seconds) {
  //   this.timeoutHandle;
  //   var that = this;
  //   function tick() {
  //     that.timerexpire =
  //       minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
  //     seconds--;
  //     if (seconds >= 0) {
  //       that.timeoutHandle = setTimeout(tick, 1000);
  //     } else {
  //       if (minutes >= 1) {
  //         setTimeout(function () {
  //           that.countdown(minutes - 1, 59);
  //         }, 1000);
  //       }
  //     }

  //     if (that.timerexpire == "0:00") {
  //       that.OptTimerbtnShow = false;
  //     }
  //   }
  //   tick();
  // }
    // new timer
  startTime() {
  const expireTime = new Date().getTime() + 2 * 60 * 1000; // 2 minutes from now
  this.startCountdown(expireTime);
}

startCountdown(expireTimestamp: number) {
  const tick = () => {
    const now = new Date().getTime();
    const remaining = expireTimestamp - now;

    if (remaining <= 0) {
      this.timerexpire = "0:00";
      this.OptTimerbtnShow = false;
      return;
    }

    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    this.timerexpire = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    setTimeout(tick, 1000);
  };

  tick();
}



  isValidOtpemail() {
    if (!this.eVerifyOTP || this.eVerifyOTP == undefined) {
      return true;
    } else {
      return false;
    }
  }

    onOtpChangeverify(e) {
    if (e.length == 6) {
      this.eVerifyOTP = e.toString();
    } else {
      this.eVerifyOTP = "";
    }
  }

  async sendEmailMobileOtp() {
    this.OptTimerbtnShow = true;
    this.startTime();
    this.commonP.presentLoading();
    let body = {
    }
    this.commonP.presentLoading();
    this.auth.SendOTPByEmailandMobile(body, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {
        console.log('sendEmail&MobileOtpSucess', data);
        this.maskedEmail = data?.response?.content?.email
        this.mobilNomasked = data?.response?.content?.mobile
        // empty email otp
        this.eVerifyOTP = ""; // Reset variable
        if (this.otpInput) {
          this.otpInput.setValue(''); // Use the NgOtpInputComponent method to reset
        }

        // Reset mobile OTP
        // this.Mverifyotp = "";
        // if (this.otpInputMobile) {
        //   this.otpInputMobile.setValue('');
        // }

         
        this.commonP.hideLoading();
        this.showModal(1, "");

      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this.router, data);

      }
    });
  }

 async resendEmailOTP() {
    this.OptTimerbtnShow = true;
    this.startTime();
    let body = {
    }
    this.commonP.presentLoading();
    this.auth.ResendOTPByEmailnMobile(body, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {
        console.log('sendEmailOtpSucess', data);
        this.maskedEmail = data?.response?.content?.email
        this.commonP.hideLoading();


      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this.router, data);

      }
    });
  }

  VerifyEmailOTP() {
    let body = {
      OTPCode: this.eVerifyOTP,
      FirebaseToken: null
    }
    this.commonP.presentLoading();
    this.auth.VerifyOTPByEmailnMobile(body, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {
        console.log('VerifyOTPByEmailnMobile', data);
        this.maskMobileNO = data?.response?.content?.mobile
       this.next();
        //  this.commonP.hideLoading();
        //  this.showModal(24, "");

      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this.router, data);

      }
    });
  }

}
